import AbstractGroupItem from '../../item/abstractGroupItem';

/**
 * Fully recessed strategy
 * Checks if item depth completely fits into foam depth
 *
 * @class FullyRecessedStrategy
 */
export default class FullyRecessedStrategy {
    /**
     * @param {number} bagDepthPadding
     */
    constructor(bagDepthPadding) {
        this.bagDepthPadding = bagDepthPadding;
    }

    /**
     * Returns if item depth is valid
     *
     * @param {FigureItem} item Item to check
     * @return {boolean} True if item fits
     */
    checkItemDepth(item) {
        if (item.type !== 'figure' && !(item instanceof AbstractGroupItem)) {
            return true;
        }

        const foam = item.getParentItem();
        const bagDepthPading = this.bagDepthPadding;
        const millingDepth = Math.max(item.get('totalDepth'), foam.get('minDepth'));
        const safetyDistance = foam.get('safetyDistanceBottom');
        const thickness = foam.get('thickness');

        return Math.floor(millingDepth * 10) <= Math.ceil((thickness - safetyDistance - bagDepthPading) * 10);
    }
}
